import { render, staticRenderFns } from "./RDStation.vue?vue&type=template&id=0804beb8&scoped=true&"
import script from "./RDStation.vue?vue&type=script&lang=js&"
export * from "./RDStation.vue?vue&type=script&lang=js&"
import style0 from "./RDStation.vue?vue&type=style&index=0&id=0804beb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0804beb8",
  null
  
)

export default component.exports